import { createStandardAction } from 'typesafe-actions';

export const setApplicationSettings = createStandardAction(
  'APP/SET_APPLICAION_SETTINGS'
)<Record<string, any>>();
